import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import {
  IPayPalConfig,
  ICreateOrderRequest
} from 'ngx-paypal';






@Component({
  selector: 'app-pagina-di-prova',
  templateUrl: './pagina-di-prova.component.html',
  styleUrls: ['./pagina-di-prova.component.css']
})
export class PaginaDiProvaComponent implements OnInit {

  public payPalConfig?: IPayPalConfig;
    showSuccess: boolean = false;
  showCancel: boolean = false;
  showError: boolean = false;

  constructor(private router: Router) {



  }

  ngOnInit(): void {
    this.initConfig();
  }

  private initConfig(): void {
    this.payPalConfig = {
      currency: 'EUR',
      clientId: 'ATZGT8QrikMkDp0KFJKhpWPEIlUFw3r30xSouzL2-Nr-CtDtUuNQNFV_8lMPSgNfaXqgQfZFElV2eJtb',
      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [{
          amount: {
            currency_code: 'EUR',
            value: '1.00',
            breakdown: {
              item_total: {
                currency_code: 'EUR',
                value: '1.00'
              }
            }
          },
          items: [{
            name: 'prova',
            quantity: '1',
            unit_amount: {
              currency_code: 'EUR',
              value: '1.00',
            },
          }]
        }]
      },
      advanced: {
        commit: 'true'
      },
      style: {
        layout: 'vertical',
        shape: 'pill',
        label: 'paypal'
      },
      onApprove: (data, actions) => {
        console.log('onApprove - transaction was approved, but not authorized', data, actions);
        actions.order.get().then((details: any) => {
          console.log('onApprove - you can get full order details inside onApprove: ', details);
          this.router.navigate(["/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/pagamento-ok/"]);
        });

      },
      onClientAuthorization: (data) => {
        console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
        this.showSuccess = true;
      },
      onCancel: (data, actions) => {
        console.log('OnCancel', data, actions);
        this.showCancel = true;
        this.router.navigate(["/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/pagamento-annullato/"]);

      },
      onError: err => {
        console.log('OnError', err);
        this.showError = true;
        this.router.navigate(["/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/pagamento-annullato/"]);
      },
      onClick: (data, actions) => {
        console.log('onClick', data, actions);
      }
    };
  }
}
